<template>
  <div name="hres7fe-group">
    <div class="evaluation-header clearfix cursor-pointer border-top-color-skin" @click="toggleGroup()">
      <div class="col-xs-8 clear-padding">
        <div class="col-xs-12 col-md-3 clear-padding">{{ labels['HRES7FEC2']['30'] }} {{ dataGroup.numgrup }}</div>
        <div class="col-xs-12 col-md-7 clear-padding evaluation-title">{{ dataGroup.desgrup }}</div>
      </div>
      <div class="col-xs-4 clear-padding evaluation-score">{{ calResultScore(dataGroup) }}/{{ calTotalScore(dataGroup) }}</div>
    </div>
    <div class="evaluation-body" v-show="groupDisp">
      <div class="evaluation-section clearfix">
        <template v-for="(item, index) in dataGroup.numitem">
          <hres7fe-item :dataGroup="dataGroup"
                        :item="item"
                        :choices="choices"
                        :name="name" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import hres7feItem from 'components/hres7fe/item'

export default {
  name: 'hres7fe-group',
  data () {
    return {
      groupDisp: true
    }
  },
  props: {
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleGroup () {
      this.groupDisp = !this.groupDisp
    },
    calResultScore (dataGroup) {
      let groupQtyscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyscor', groupQtyscor)
      return groupQtyscor
    },
    calTotalScore (dataGroup) {
      let groupQtyfscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyfscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyfscor', groupQtyfscor)
      return groupQtyfscor
    }
  },
  components: {
    hres7feItem
  }
}
</script>


// WEBPACK FOOTER //
// group.vue?4b6d4be0